<script>
import { format, parseISO } from 'date-fns/fp'

export default {
  props: {
    challenge: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {}
  },
  computed: {
    postTypes() {
      return this.challenge.post_types
    },
    goals() {
      return this.challenge.goals
    },
    groups() {
      return this.goals.filter((item) => item.type === this.postTypes)
    },
    leftGroupGoal() {
      return this.groups[0] && this.groups[0].achieved
        ? this.groups[0].achieved
        : 0
    },
    rightGroupGoal() {
      return this.groups[1] && this.groups[1].achieved
        ? this.groups[1].achieved
        : 0
    },
    pointGoal() {
      return this.groups[0] && this.groups[0].goal ? this.groups[0].goal : 1
    },
    leftProgress() {
      return Math.round((this.leftGroupGoal.achieved / this.pointGoal) * 504)
    },
    rightProgress() {
      return Math.round((this.rightGroupGoal.achieved / this.pointGoal) * 504)
    },
    start() {
      return format('M/d/yy h:mma', parseISO(this.challenge.start))
    },
    end() {
      return format('M/d/yy h:mma', parseISO(this.challenge.end))
    },
  },
}
</script>

<template>
  <div class="flex h-full items-end relative">
    <img
      class="w-full items-end"
      src="https://kyndhub-upload-dev.s3.us-west-1.amazonaws.com/uploads/status_updates/5f3ca7f3c01612.119165580.jpg"
    />
    <div class="absolute inset-0 bg-blue-lighter bg-opacity-25">
      <h3 class="text-3xl text-blue-darker pt-4 pl-5">{{ challenge.name }}</h3>
      <div class="flex w-full mt-48 relative">
        <!-- left progress bar -->
        <div
          class="absolute left-0 top-0 transform"
          :class="[$style.lineWidth, $style.rotateL]"
        >
          <div class="flex items-center mb-3 -mr-20">
            <div
              class="h-3 bg-white rounded-lg"
              :style="{ width: `${leftProgress}px` }"
            />
            <div
              class="bg-blue w-14 h-14 rounded-full text-white text-2xl font-bold text-center  leading-2xl transform -ml-6"
            >
              <div class="transform" :class="$style.rotateR">1</div>
            </div>
          </div>
          <!-- base blue line -->
          <div class="h-2 bg-blue-darker rounded-lg ml-5"></div>
        </div>
        <!-- right progress bar -->
        <div
          class="absolute right-0 top-0 transform"
          :class="[$style.lineWidth, $style.rotateR]"
        >
          <div class="flex items-center mb-3 justify-end -ml-20">
            <div
              class="bg-blue w-14 h-14 rounded-full text-white text-2xl font-bold text-center  leading-2xl transform -mr-6"
            >
              <div class="transform" :class="$style.rotateL">2</div>
            </div>
            <div
              class="h-3 bg-white rounded-lg"
              :style="{ width: `${rightProgress}px` }"
            />
          </div>
          <!-- base blue line -->
          <div class="h-2 bg-blue-darker rounded-lg mr-5"></div>
        </div>
      </div>
      <div class="absolute w-full pt-16 flex justify-center">
        <div v-if="challenge.goalSetting === 'time'">
          <div
            class="bg-white text-blue-darker font-bold text-32xl h-12 leading-loose px-4 relative"
            :class="[$style.leftTriangle]"
          >
            {{ start }}
          </div>
          <div class="text-blue-darker text-center my-1">to</div>
          <div
            class="bg-white text-blue-darker font-bold text-32xl h-12 leading-loose px-4 relative"
            :class="[$style.rightTriangle]"
          >
            {{ end }}
          </div>
        </div>
        <div
          v-else
          class="bg-white text-blue-darker font-bold text-32xl h-12 leading-loose px-4 relative"
          :class="[$style.leftTriangle, $style.rightTriangle]"
        >
          {{ pointGoal }} Point Goal
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.lineWidth {
  width: 459px;
}
.rotateL {
  --transform-rotate: -50deg;
}
.rotateR {
  --transform-rotate: 50deg;
}
.leftTriangle::before {
  position: absolute;
  bottom: 0;
  left: -16px;
  content: '';
  border-top: 24px solid #fff;
  border-bottom: 24px solid #fff;
  border-left: 16px solid transparent;
}
.rightTriangle::after {
  position: absolute;
  right: -16px;
  bottom: 0;
  content: '';
  border-top: 24px solid #fff;
  border-right: 16px solid transparent;
  border-bottom: 24px solid #fff;
}
</style>
